import React, { useState, useEffect, useRef } from "react";
import {
  getAxiosResponse,
  postAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { useTranslation } from "react-i18next";
import { transformBlankToNull } from "../../../services/Util";
import { encodePassword } from "../../../services/Util";
import $ from "jquery";
import { useSelector } from "react-redux";
import Constants from "../../../Constants";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import { rolePermissionSelected } from '../../../redux/reducers/RolePermissionSlice';

export default function Api(prop) {

  const { t } = useTranslation();
	const translate = t;
  const owner = useSelector(
    (loginSessionDetail) => loginSessionDetail.loginSession
  ).value;
  const inputRef = useRef(null);
  const modalRef = useRef();
  const user = prop.user.resource;

  const [password, setPassword] = useState("");
  const [action, setAction] = useState("");
  const [url, setUrl] = useState("");
  const [auth2CredentialStatus, setAuth2CredentialStatus] = useState({});
  const [accessKey, setAccessKey] = useState("");
  const [clientId, setClientId] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [userDetail, setUserDetail] = useState({});
  const [generateKeyValue, setGenerateKeyValue] = useState(false);
  const [generateCredValue, setGenerateCredValue] = useState(false);
  const [error, setError] = useState("");
  const [ownerRole, setOwnerRole] = useState("");

  const userPermissions = useSelector(
    (rolePermissionSelected) => rolePermissionSelected.role_permission,
  ).value;

  const customerBootstrapData = useSelector(reduxStore => reduxStore.customer_bootstrap_data).value;

  const isSsoUser = () => { return (userDetail.azureSsoEnabled || userDetail.samlEnabled || customerBootstrapData.authenticationType === 'WELOCALIZE_OKTA')};

    useEffect(() => {
        if(action !=="" && url !=="" && isSsoUser()) {
            postApiCred();
        }
    },[action, url]);

  const showModel = (action, url) => {
    modalRef.current = document.activeElement.id;
    setAccessKey("");
    setClientId("");
    setClientSecret("");
    setPassword("");
    setAction(action);
    setUrl(url);
    document.body.classList.add("modal-open");
    setTimeout(() => {
        if(inputRef.current != null){
            inputRef.current.focus();
        }
    }, 400);
  };
  const hideModel = () => {
    $("#" + modalRef.current).trigger("focus");
    setError("");
    setAccessKey("");
    setClientId("");
    setClientSecret("");
    setPassword("");
    setUrl("");
    setAction("");
    getAuth2Status();
    document.body.classList.remove("modal-open");
  };
  const getAuth2Status = () => {
    getAxiosResponse(APIUrls.CHECK_AUTH2_CREDENTIALS).then((res) => {
      setAuth2CredentialStatus(res.data.data.body.oauth2CredentialsExists);
      if (url === "oauth" && action === "DELETE") {
          setGenerateCredValue(true);
      }
    });
    getAxiosResponse(APIUrls.GET_FULL_USER_BY_ID(user.userId))
      .then((res) => {
        setUserDetail(res.data.data.resource);
        setTimeout(() => {
          $('.blue-btn.active').each(function(index, element){
            element.id = 'modal-btn-' + index;
          })
        }, 300);
        if (url === "accessKey" && action === "DELETE") {
          setGenerateKeyValue(true);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  useEffect(() => {
    getAuth2Status();

    $(document).ready(function(){
      $('.blue-btn.active').each(function(index, element){
        element.id = 'modal-btn-' + index;
      })
    });
    if(owner !== "") {
      setOwnerRole(owner?.role.find((obj) => obj.value === Constants.ROLE_CUSTOMER_ADMIN)?.value);
    }
  }, []);

  useEffect(()=>{
    if (generateKeyValue) {
      $('.generateKey').trigger('focus');
      setGenerateKeyValue(false);
    }
    if (generateCredValue) {
      $('.generateCredential').trigger('focus');
      setGenerateCredValue(false);
    }
  }, [generateKeyValue, generateCredValue]);

  const handleModalFocus = (event) => {
    if (event.keyCode == 27) {
      hideModel();
    }

    if (document.activeElement.id === "cancel-after-auth" && event.keyCode == 9) {
      event.preventDefault();
    }

    if (document.activeElement.id === "cancel" &&
    event.keyCode === 9 &&
    event.shiftKey === false) {
    event.preventDefault();
    $("#email-link").trigger("focus");
    } else if (
      document.activeElement.id === "email-link" &&
      event.shiftKey && event.keyCode == 9
    ) {
    event.preventDefault();
    $("#cancel").trigger("focus");
    }
  }

  const postApiCred = () => {
    var pass = encodePassword(password);
    var payload = {};
    if (action === "GENERATE") {
      payload = {
        action: "GENERATE",
        data: null,
        errors: {},
        password: pass,
        success: true,
      };
    } else {
      payload = {
        action: action,
        password: pass,
      };
    }

    var nulledPayload = transformBlankToNull(payload);
    if (url === "accessKey") {
      postAxiosResponse(APIUrls.API_ACCESS_TOKEN, nulledPayload).then((res) => {
        var response = res.data.data.body;
        if (response.success !== false) {
          if (action === "DELETE") {
            hideModel();
          } else {
            setAccessKey(response.token);
            setTimeout(() => {
              hideModel();
            }, 120000);
            setTimeout(function(){
              $("#cancel-after-auth").trigger("focus");
            }, 300);
          }
        } else {
          setError("invalid password. Please try again");
          $('#emailPassword').trigger('focus');
        }
      });
    }
    if (url === "oauth") {
      postAxiosResponse(APIUrls.API_AUTH2_TOKEN, nulledPayload).then((res) => {
        var response = res.data.data.body;
        if (response.success !== false) {
          if (action === "DELETE") {
            hideModel();
          } else {
            setClientId(response.clientId);
            setClientSecret(response.clientSecret);
            setTimeout(function(){
              $("#cancel-after-auth").trigger("focus");
            }, 300);
          }
        } else {
          setError("invalid password. Please try again");
          $('#emailPassword').trigger('focus');
        }
        getAuth2Status();
      });
    }
    getAuth2Status();
  };

  return (
    <>
      <h5 className="heading-width-border">
{translate("my_account.api_integration")}      </h5>
      <div className="API-tab-list">
        <h5 className="heading-width-border">{translate("my_account.cloud_api")}</h5>
        <p>
{translate("my_account.cloudwords_api")}
        </p>
        <h5 className="heading-width-border">
          {translate("my_account.third_party_application")}
        </h5>
        <p>
          To allow a third-party application to{" "}
          <b>act on behalf of your OPAL-Marketing user account</b> and interact with
          OPAL-Marketing, we require it to use an "access key" that can only be
          generated by you. You can delete the generated "access key" at any
          time to disable third-party application access.
        </p>
      </div>
      <div className="API-tab-list">
        <h5 className="heading-width-border">{translate("my_account.access_key")}</h5>
        <p>
       { translate("my_account.api_access_key")}
        </p>
        {userDetail?.hasApiToken ? (
          <div className="flex two-col">
            <button
              className="blue-btn active"
              onClick={() => showModel("VIEW", "accessKey")}
            >
              View Access key
            </button>
            <button
              className="blue-btn active"
              onClick={() => showModel("DELETE", "accessKey")}
            >
              Delete Access key
            </button>
          </div>
        ) : (
          <button
            className="blue-btn active generateKey"
            onClick={() => showModel("GENERATE", "accessKey")}
          >
            Generate Access Key
          </button>
        )}
      </div>
      {user.userId === owner.id && ownerRole === "ROLE_CUSTOMER" && userPermissions.includes("ADMINISTRATION") && <div className="API-tab-list">
        <h5 className="heading-width-border">{translate("my_account.oauth2_credentials")}</h5>
        <p>
        {translate("my_account.cloudwords_oauth_2")}
        </p>
        {auth2CredentialStatus ? (
          <div className="flex two-col">
            <button
              className="blue-btn active"
              onClick={() => showModel("VIEW", "oauth")}
            >
              View Credentials
            </button>
            <button
              className="blue-btn active"
              onClick={() => showModel("DELETE", "oauth")}
            >
              Delete Credentials
            </button>
          </div>
        ) : (
          <div className="flex two-col">
            <button
              className="blue-btn active generateCredential"
              onClick={() => showModel("GENERATE", "oauth")}
            >
              Generate Credentials
            </button>
          </div>
        )}
      </div>}
      <div className="API-tab-list">
        <h5 className="heading-width-border"> {translate("my_account.security_warning")}</h5>
        <p>
      {translate("my_account.be_careful")}
        </p>
      </div>
      <div className="lightbox-panel"
        aria-labelledby="keyModal" aria-modal="true" role="dialog"
      >
        {accessKey === "" && clientId === "" && clientSecret === "" ? (
          <div className="inner-lightbox-panel pb-0" onKeyDown={(e) => handleModalFocus(e)}>
            { isSsoUser() ? (
            <>
                <div className="modal-header flex padd-lr">
                    <h5 id="keyModal">{(url === "accessKey")?"Access Key":"Oauth 2 Credential"}</h5>
                </div>
                <div className="lightbox-content padd-22">
                    <div className="confirm-pass-block">
                        <div className="flex wrap-dropdown">Loading...</div>
                    </div>
                </div>
                <div className="modal-footer modal-footer-border flex px-22">
                    <button id="cancel" className="btn btn-bold" onClick={hideModel} ref={inputRef}>
                        Cancel
                    </button>
                </div>
            </>
            ):(
            <>
            <div className="modal-header flex padd-lr">
              <h5 id="keyModal">Please confirm your password {accessKey}</h5>
            </div>
            <div className="lightbox-content padd-22">
              <div className="confirm-pass-block">
                <div className="flex wrap-dropdown">
                  {error !== "" ? <p className="error" id="errorEmail">{error}</p> : ""}
                  <div className="global-dropdown-block">
                    <label>Email</label>
                    <a
                      id="email-link"
                      className="email-link"
                      href="mailto:sunil.tripathy@cloudwords.com"
                    >
                      {userDetail.email}
                    </a>
                  </div>
                </div>
                <div className="flex wrap-dropdown">
                  <div className="global-dropdown-block">
                    <label>Password</label>
                    <input
                      type="password"
                      className="form-control-sm"
                      placeholder="Password"
                      aria-describedby="errorEmail"
                      id="emailPassword"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
              <button id="submit" className="btn btn-bold active" onClick={postApiCred}>
                Submit
              </button>
              <button id="cancel" className="btn btn-bold" onClick={hideModel}
              ref={inputRef}
              >
                Cancel
              </button>
            </div>
            </>
            )}
          </div>
        ) : (
          <div className="inner-lightbox-panel pb-0" onKeyDown={(e) => handleModalFocus(e)}
            aria-labelledby="credentialModal" aria-modal="true" role="dialog"
          >
            <div className="modal-header flex padd-lr">
              {accessKey !== "" ? (
                <h5 id="credentialModal">Your OPAL-Marketing API Access Key</h5>
              ) : clientId !== "" && clientSecret !== "" ? (
                <h5 id="credentialModal">Your OPAL-Marketing OAuth 2 credentials</h5>
              ) : null}
            </div>
            <div className="lightbox-content padd-22">
              <div className="confirm-pass-block">
                <div className="flex wrap-dropdown">
                  <p>
                    Please share the following key with the person implementing
                    your integration with OPAL-Marketing.
                    {accessKey !== "" ? (
                      <>
                        For security purposes, this window will automatically
                        close in 2 minutes.
                      </>
                    ) : null}
                  </p>
                </div>
                <div className="flex wrap-dropdown">
                  {accessKey !== "" ? (
                    <p className="api-token">
                      <code>{accessKey}</code>
                    </p>
                  ) : clientId !== "" && clientSecret !== "" ? (
                    <>
                      <p className="api-token">
                        Client Id : <code>{clientId}</code>
                      </p>
                      <p className="api-token">
                        Client Secret : <code>{clientSecret}</code>
                      </p>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
              {accessKey === "" && clientId === "" && clientSecret === "" ? (
                <button className="btn btn-bold active" onClick={postApiCred}>
                  Submit
                </button>
              ) : null}
              <button id="cancel-after-auth" className="btn btn-bold" onClick={hideModel}>
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
